import Highcharts from 'highcharts';
import { useEffect, useMemo } from 'react';
import { cookie } from 'react-cookies';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { currentTeam } from '../../../recoil/atoms/currentTeam';
import { endingDate } from '../../../recoil/atoms/endingDate';
import { startingDate } from '../../../recoil/atoms/startingDate';
import { user } from '../../../recoil/atoms/user';
import { getAgentReport } from '../../../recoil/selectors/getAgentReport';
import { methodNameEnum } from '../../../recoil/selectors/makePHPRequest';
import { permissionsSelector } from '../../../recoil/selectors/permissionsSelector';
import {
  endpointEnum,
  makeAPIRequest,
} from '../../../services/rest/makeAPIRequest';
import { AgentSummary } from '../../subpages/AgentSummary';
import { HighchartsReactWithStyles } from './HighchartsReactWithStyles';
const AgentReportCharts = (props) => {
  const [starting] = useRecoilState(startingDate);
  const [ending] = useRecoilState(endingDate);
  const accessToken = cookie?.load('accessToken');
  const agentReport = useRecoilValueLoadable(
    getAgentReport({
      urlStartingDate: starting,
      urlEndingDate: ending,
      accessToken: accessToken,
    })
  );
  const data = agentReport?.contents?.agentReporting || {};
  const totalCallsOptions = data.totalCalls || {};
  const totalOutgoingOptions = data.totalOutgoing || {};
  const totalIncomingOptions = data.totalIncoming || {};
  const permissionsLoadable = useRecoilValueLoadable(permissionsSelector);
  const { role } = permissionsLoadable.contents;
  const [_team, setTeam] = useRecoilState(currentTeam);

  const businessData = useRecoilValueLoadable(
    makeAPIRequest({
      endpoint: endpointEnum.GET_BUSINESS_DATA,
      payloadJsonString: JSON.stringify({
        call: methodNameEnum.GET_BUSINESS_DATA,
      }),
    })
  );

  const canViewCallReporting = useMemo(() => {
    if (businessData?.contents?.response?.data) {
      if (
        businessData?.contents?.response?.data?.result?.[0] &&
        businessData?.contents?.response?.data?.result?.[0]
          ?.onlyManagersCanViewCallReporting === 1
      ) {
        return role === 'superadmin' || role === 'admin' || role === 'manager';
      }
      if (
        (businessData?.contents?.response?.data?.result?.[0] &&
          businessData?.contents?.response?.data?.result?.[0]
            ?.onlyManagersCanViewCallReporting === 0) ||
        props?.props?.match?.url?.includes('my-profile')
      ) {
        return true;
      }
    } else {
      return false;
    }
  }, [businessData, role]);

  useEffect(() => {
    if (props?.props?.match?.params?.id && canViewCallReporting === false) {
      setTeam({
        id: 0,
        name: 'singleUserFlag',
        userid: Number(props?.props?.match?.params?.id),
      });
    }
  }, [canViewCallReporting, props]);
  useEffect(() => {
    return () => setTeam({ id: 0, name: 'All Teams' });
  }, []);
  const userAtom = useRecoilValueLoadable(user);
  const loginUser = userAtom.contents?.user ?? {};

  return (
    <>
      {canViewCallReporting === false ? (
        <AgentSummary singleAgent={true} />
      ) : (
        <div role="tabpanel">
          <div>
            <HighchartsReactWithStyles
              allowChartUpdate={true}
              highcharts={Highcharts}
              options={JSON.parse(JSON.stringify(totalCallsOptions ?? null))}
              loading={agentReport.state === 'loading'}
            />
          </div>
          <br />
          <div>
            <HighchartsReactWithStyles
              allowChartUpdate={true}
              highcharts={Highcharts}
              options={JSON.parse(JSON.stringify(totalOutgoingOptions ?? null))}
              loading={agentReport.state === 'loading'}
            />
          </div>
          <br />
          <div>
            <HighchartsReactWithStyles
              allowChartUpdate={true}
              highcharts={Highcharts}
              options={JSON.parse(JSON.stringify(totalIncomingOptions ?? null))}
              loading={agentReport.state === 'loading'}
            />
          </div>
          {window.location.pathname ===
            `/my-profile/${loginUser.userid}/agent-reporting` && (
            <AgentSummary singleAgent={true} />
          )}
        </div>
      )}
    </>
  );
};
export default AgentReportCharts;
